import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { DH } from '../../../../utils/dataHooks';
import { MorePaymentOptions } from '../../../MorePaymentOptions';
import { useExpressButtons } from '../../hooks/useExpressButtons';
import { ExpressButtons } from '../ExpressButtons';
import { classes } from './styles.st.css';

const TRANSITION_TIMEOUT = 400;

type ExpandableListProps = {
  isExpanded?: boolean;
  onExpand(): void;
};

export const ExpandableList: React.FC<ExpandableListProps> = (props) => {
  const { isExpanded, onExpand } = props;
  const { items, onTopLevelCount } = useExpressButtons({ expandableView: true });

  return (
    <div data-hook={DH.Widget.PMList}>
      <ExpressButtons vertical items={items.slice(0, onTopLevelCount)} place="onTopLevel" />
      {items.length > onTopLevelCount && (
        <>
          <CSSTransition
            in={!isExpanded}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              exit: classes.exit,
              exitActive: classes.exitActive,
              exitDone: classes.exitDone,
            }}
          >
            <div data-hook={DH.Widget.MorePoWrapper} data-hidden={isExpanded}>
              <MorePaymentOptions onClick={onExpand} />
            </div>
          </CSSTransition>
          <CSSTransition
            in={isExpanded}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              enter: classes.enter,
              enterActive: classes.enterActive,
              enterDone: classes.enterDone,
            }}
          >
            <div className={classes.restSources}>
              <ExpressButtons
                vertical
                items={items.slice(onTopLevelCount)}
                place="insideShowMore"
                className={isExpanded ? classes.showMoreButtons : ''}
              />
            </div>
          </CSSTransition>
        </>
      )}
    </div>
  );
};
